const coupon = {
	namespaced: true,
	state: {
		obj: {} // 票券信息
	},
	mutations: {
		updateObj(state, payload) {
			state.obj = payload;
		},
	},
	actions: {

	}
}

export default coupon



// WEBPACK FOOTER //
// ./src/store/mine/coupon.js